<template>
    <div class="wrapper-cold-stock animated fadeIn">
        <div class="card">
            <div class="card-header">
                <div>List</div>
            </div>

            <div class="card-body">
                <div class="siot-table-wrapper">
                    <div class="siot-table-header">
                        <div class="siot-table-header-left">
                            <div class="siot-table-search">
                                <div class="siot-table-search-field">
                                    <input type="text" id="coldstockSearch" v-model="filter" v-on:keyup="searchKeyUp" v-on:keydown="searchKeyDown" placeholder="Search">
                                </div>
                            </div>
                            <div class="siot-table-filter">
                                <button class="btn btn-primary filters-button" @click="openFilters()"><i class="fa fa-filter"></i> Filter</button>
                            </div>
                            <div class="siot-table-sort">
                                <button id="simManagmentSort" @click="shwoHideSort()" class="btn btn-primary mobile-sort-btn"><i aria-hidden="true" class="fa fa-sort"></i>Sort</button>
                            </div>
                        </div>

                        <div class="siot-table-header-right">
                            <div class="siot-table-coldstock">
                                <button v-if="coldStockAccess === 'true'" class="btn btn-primary action-element" id="addToColdStockButton" @click="showClodStock()">Add to Cold Stock</button>
                            </div>
                            <div class="siot-table-export">
                                <button class="btn btn-primary" id="exportColdstock" @click="showExportSelect()">Export Cold Stock</button>
                            </div>
                            <div class="siot-table-size">
                                <label for="size-page">Display:</label>
                                <select v-on:change="sizePage" v-model="sortSettings.size" id="size-page" class="form-control custom-select">
                                    <option value="40">40</option>
                                    <option value="60">60</option>
                                    <option value="80">80</option>
                                    <option value="100">100</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="siot-table-content">
                        <div class="siot-table">
                            <div v-if="mobileVisible == true" class="cold-stock-mobile">
                                <div class="list-mobile">
                                    <div class="item-mobile" v-for="(item, index) in coldStockList" :data-iccid="item.iccid" v-bind:key="index">
                                        <div class="item-header-mobile">
                                            <div class="icon">
                                                <img v-if="item.carrierId == 1" src="../../assets/img/carrier-simon.svg"/>
                                                <img v-else-if="item.carrierId == 2" src="../../assets/img/carrier-tmobile.svg"/>
                                                <img v-else-if="item.carrierId == 3" src="../../assets/img/carrier-vodafone.svg"/>
                                                <img v-else src="../../assets/img/carrier-simon.svg"/>
                                            </div>

                                            <div class="info-wrapper-mobile">
                                                <div class="info-mobile">
                                                    <strong>{{item.iccid}}</strong>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-else class="siot-table table-responsive-sm table-coldstock-bank-component">
                                <table  v-if='coldStockList' class="table b-table table-striped table-hover b-table-selectable b-table-select-multi">
                                    <thead role="rowgroup">
                                        <tr role="row">
                                            <th v-on:click="changesSort(1)" role="columnheader" :aria-sort="setAreaSort(1)">SIM</th>
                                            <th v-on:click="changesSort(2)" role="columnheader" :aria-sort="setAreaSort(2)">Carrier</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr v-for="(item, index) in coldStockList" :data-iccid="item.iccid" v-bind:key="index">
                                            <td>{{item.iccid}}</td>
                                            <td>
                                                <span v-if="item.carrierId == 1">SimonIoT</span>
                                                <span v-else-if="item.carrierId == 2">T-Mobile</span>
                                                <span v-else-if="item.carrierId == 3">Vodafone</span>
                                                <span v-else-if="item.carrierId == 4">Kore</span>
                                                <span v-else>--</span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="loader-sim-list" v-if="loadingColdSims && noSims == false">
                            <div class="sk-wave">
                                <div class="sk-rect sk-rect1"></div>&nbsp;<div class="sk-rect sk-rect2"></div>&nbsp;<div class="sk-rect sk-rect3"></div>&nbsp;<div class="sk-rect sk-rect4"></div>&nbsp;<div class="sk-rect sk-rect5"></div>&nbsp;
                            </div>
                        </div>

                        <div class="no-sims" v-if="noSims">
                            <h2 class="text">You have no Cold SIMs</h2>
                        </div>
                    </div>
                    <div class="siot-table-footer">
                        <div class="siot-table-footer-center">
                            <nav v-if="paginationCount" aria-label="Page navigation example">
                                <paginate :page-count="paginationCount" v-model="sortSettings.page" :click-handler="paginationControll" :prev-text="'Prev'" :next-text="'Next'" :container-class="'pagination justify-content-center'" :page-class="'page-item'" :page-link-class="'page-link'" :prev-class="'page-item'" :prev-link-class="'page-link'" :next-class="'page-item'" :next-link-class="'page-link'"></paginate>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div :class="['wrapper-modal', (showfileFormatPopup) ? '' : 'wrapper-disable']">
            <div class="file-format-popup">
                <i class="close-icon fa fa-close" v-on:click="showfileFormatPopup = false"></i>
                <img src="../../assets/img/file-format.svg">
                <h3>Save export file as:</h3>
                <div>
                    <button class="btn btn-primary csv" v-on:click="exportCsv">CSV</button>
                    <button class="btn btn-primary xls" v-on:click="exportXlsx">XLSX</button>
                </div>
                <button class="btn btn-light" v-on:click="showfileFormatPopup = false">Cancel</button>
            </div>
        </div>
        <b-modal size="md" ref="selectCarrier" id="selectCarrier" centered hide-footer>
            <img src="../../assets/img/sim-card4.png" alt="">

            <strong>Select Carrier</strong>
            <p>Choose a cold stock sim carrier</p>

            <div class="select-carrier-box">
                <div v-if="simonCarrierAvailable" @click="showAddColdStock(1)" id="simonCarrierSelect" class="carrier-option">
                    <img src="../../assets/img/lightlogo.svg" class="light-version" alt="">
                    <img src="../../assets/img/darklogo.svg" class="dark-version" alt="">
                </div>
                <div v-if="tmobileCarrierAvailable" @click="showAddColdStock(2)" id="tmobileCarrierSelect" class="carrier-option">
                    <img src="../../assets/img/t-mobile-carrier.svg" alt="" class="light-mode">
                    <img src="../../assets/img/tmobile-carrier-dark.svg" alt="" class="dark-version">
                </div>
                <div v-if="vodafoneCarrierAvailable" @click="showAddColdStock(3)" id="vodafoneCarrierSelect" class="carrier-option">
                    <img src="../../assets/img/vodafone-logo.svg" alt="" class="light-mode">
                    <img src="../../assets/img/vodafone-logo.svg" alt="" class="dark-version">
                </div>
                <div v-if="koreCarrierAvailable" @click="showAddColdStock(4)" id="koreCarrierSelect" class="carrier-option">
                    <img src="../../assets/img/kore-logo.svg" alt="" class="light-mode">
                    <img src="../../assets/img/kore-logo.svg" alt="" class="dark-version">
                </div>
            </div>
        </b-modal>
        <b-modal size="md" ref="fileFormatModal" id="fileFormatModal" centered hide-footer>
            <div class="file-format-popup">
                <img src="../../assets/img/file-format.svg">
                <h3>Save export file as:</h3>
                <div>
                    <button class="btn btn-primary csv" v-on:click="exportCsvNew">CSV</button>
                    <button class="btn btn-primary xls" v-on:click="exportXlsxNew">XLSX</button>
                </div>
                <button class="btn btn-light" @click="hideExportSelect()">Cancel</button>
            </div>
        </b-modal>
        <b-modal id="filtersModal" ref="filtersModal" centered hide-header hide-footer>
            <div class="filters-inner">
                <div class="carrier-column">
                    <h3>Carrier</h3>
                    <FTScheckbox @change.native="filtersAllCarriers()" :label="'All'" v-model="filters.carrier.all"></FTScheckbox>
                    <FTScheckbox v-if="simonCarrierAvailable" @change.native="filtersCarrier()" :label="'Simon'" v-model="filters.carrier.simon"></FTScheckbox>
                    <FTScheckbox v-if="tmobileCarrierAvailable" @change.native="filtersCarrier()" :label="'T-Mobile'" v-model="filters.carrier.tmobile"></FTScheckbox>
                    <FTScheckbox v-if="vodafoneCarrierAvailable" @change.native="filtersCarrier()" :label="'Vodafone'" v-model="filters.carrier.vodafone"></FTScheckbox>
                    <FTScheckbox v-if="koreCarrierAvailable" @change.native="filtersCarrier()" :label="'Kore'" v-model="filters.carrier.kore"></FTScheckbox>
                </div>
                <div class="unselect-box">
                    <a v-if="filters.carrier.all" @click="unselectAllFilters()">UNSELECT ALL</a>
                    <a v-else @click="selectAllFilters()">SELECT ALL</a>
                    <i @click="cancelFilters()" class="fa fa-close"></i>
                </div>
            </div>
            <div class="control-bar">
                <div class="left-side">
                    <button class="btn btn-light" @click="setDefaultFilters()">Set default</button>
                </div>
                <div class="right-side">
                    <button class="btn btn-light" @click="cancelFilters()">Cancel</button>
                    <button class="btn btn-primary" @click="setFilters()">Apply</button>
                </div>
            </div>
        </b-modal>
        <ColdStock2 v-if="coldStock" :closeModal="closeColdStock" :carrierId="carrierId" :companyId='companyId' :addToCompany="true"></ColdStock2>
        <FTSSort v-if="mobileSort.visible" :settingsSort="sortingSettings" :directionSort="sortSettings.desc" :columnSort="sortSettings.sort" v-on:hideSort="shwoHideSort" v-on:submitSort="submitSort"></FTSSort>
    </div>
</template>

<script>
import Vue from 'vue'
import Axios from 'axios'
import globalStore from './../../variables'
import ColdStock2 from "../fulfilment/ColdStock";
import VueSession from "vue-session";
import Paginate from 'vuejs-paginate'
import VueCookies from 'vue-cookies';
import FTSSort from "../../ftsComponents/FTSSort";
Vue.use(VueCookies);
Vue.$cookies.config('7d','','',true)
import FTScheckbox from "../../ftsComponents/FTScheckbox";

Vue.use(VueSession);

export default {
    name: 'ColdStock',
    data() {
        return {
            sortMobile: {
                column: 0,
                direction: true
            },
            toggleSort: false,
            mobileVisible: false,
            visibilityOptionsButtons: false,
            filter: '',
            sortSettings: {
                page: 1,
                size: 40,
                sort: 1,
                desc: true
            },
            loadingColdSims: false,
            noSims: false,
            simsList: [],
            paginationCount: 0,
            selectedCarriers: {
                simon: 0,
                tmobile: 0,
                vodafone: 0
            },
            exportOption: '',
            showfileFormatPopup: false,
            searchString: '',
            typingTimer: '',
            companyName: '',
            coldStockList: '',
            coldStock: false,
            carrierId: 1,
            coldStockAccess: false,
            simonCarrierAvailable: true,
            tmobileCarrierAvailable: true,
            vodafoneCarrierAvailable: true,
            koreCarrierAvailable: true,
            filters: {
                carrier: {
                    all: true,
                    simon: true,
                    tmobile: true,
                    vodafone: true,
                    kore: true
                },
            },
            initialFilters: {
                carrier: {
                    all: true,
                    simon: true,
                    tmobile: true,
                    vodafone: true,
                    kore: true
                },
            },
            filterString: '',
            nbIoTAvailable: false,
            catM1Available: false,
            sortingSettings: [
                {
                    label: 'SIM',
                    column: 1
                },
                {
                    label: 'Carrier',
                    column: 2
                },
            ],
            mobileSort: {
                column: 0,
                direction: 0,
                visible: false
            }
        }
    },
    components: {
        Paginate,
        ColdStock2,
        FTScheckbox,
        FTSSort
    },
    methods: {
        submitSort(value) {
            this.sortSettings.sort = value.column;
            this.sortSettings.desc = value.direction;
            this.getColdStocks(true);
        },
        shwoHideSort() {
            this.mobileSort.visible = (this.mobileSort.visible == true) ? false : true;
        },
        showMobileElements() {
            const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

            if (width < 992) {
                this.mobileVisible = true;
            } else {
                this.mobileVisible = false;
            }
        },
        toggleVisibleOptions() {
            this.visibilityOptionsButtons = (this.visibilityOptionsButtons == true) ? false : true;
        },
        showAddColdStock(carrierId) {
            this.carrierId = carrierId
            this.$refs['selectCarrier'].hide()
            this.coldStock = true;
        },
        closeColdStock(){
            this.coldStock = false;
        },
        showClodStock() {
            let sumCarriersAvailable = 0;
            if (this.simonCarrierAvailable) {
                sumCarriersAvailable++;
            }
            if (this.tmobileCarrierAvailable) {
                sumCarriersAvailable++;
            }
            if (this.vodafoneCarrierAvailable) {
                sumCarriersAvailable++;
            }
            if (this.koreCarrierAvailable) {
                sumCarriersAvailable++;
            }
            if (sumCarriersAvailable > 1) {
                this.$refs['selectCarrier'].show()
            } else {
                if (this.simonCarrierAvailable) {
                    this.carrierId = 1;
                } else if (this.tmobileCarrierAvailable) {
                    this.carrierId = 2;
                } else if (this.vodafoneCarrierAvailable) {
                    this.carrierId = 3;
                } else if (this.koreCarrierAvailable) {
                    this.carrierId = 4;
                } else {
                    this.carrierId = 1;
                }
                this.coldStock = true;
            }
        },
        searchKeyUp() {
            clearTimeout(this.typingTimer)
            this.typingTimer = setTimeout(() => {
                this.searchRow()
            }, 500)
        },
        searchKeyDown() {
            clearTimeout(this.typingTimer)
        },
        searchRow() {
            if (this.filter.length > 0) {
                this.searchString = '&search=' + escape(this.filter);
            } else {
                this.searchString = ''
            }
            this.getColdStocks(true)
        },
        getPagination() {
            Axios.get(globalStore.data.restApiUrl + "/cold-stock/page-count?size=" + this.sortSettings.size + this.searchString + this.filterString)
                .then(response => {
                    if (response.status == 200) {
                        this.paginationCount = Number (response.data);
                    } else {
                        this.$notify({
                            type: 'warn',
                            group: 'notification',
                            title: 'Getting data error',
                            text: 'Error Retrieving Cold Stock List - Contact Support',
                            duration: 5000,
                        });

                        return false;
                    }
                }).catch(error => {
                    this.$notify({
                        type: 'warn',
                        group: 'notification',
                        title: 'Getting data error',
                        text: 'Error Retrieving Cold Stock List - Contact Support',
                        duration: 5000,
                    });
                    console.log(error)

                    return false;
                })
        },
        sizePage() {
            this.getColdStocks(true)
        },
        paginationControll(ev) {
            this.sortSettings.page = ev;
            this.getColdStocks(false);
        },
        changesSort(sortId) {
            if (sortId == this.sortSettings.sort) {
                this.sortSettings.desc = !this.sortSettings.desc
            }
            this.sortSettings.sort = sortId
            this.getColdStocks(false);
        },
        setAreaSort(sortId) {
            if (sortId != this.sortSettings.sort) {
                return 'none'
            } else if (sortId == this.sortSettings.sort && this.sortSettings.desc) {
                return 'descending'
            } else if (sortId == this.sortSettings.sort && this.sortSettings.desc == false) {
                return 'ascending'
            }
        },
        getColdStocks(notPagination) {
            this.loadingColdSims = true;
            if (notPagination){
                this.sortSettings.page = 1;
                this.getPagination();
            }
            Axios.get(`${globalStore.data.restApiUrl}/cold-stock?page=${this.sortSettings.page}&size=${this.sortSettings.size}&sort=${this.sortSettings.sort}&desc=${this.sortSettings.desc}${this.searchString}${this.filterString}`)
                .then(response => {
                    this.coldStockList = response.data
                    this.loadingColdSims = false;
                }).catch(error => {
                    this.loadingColdSims = false
                     this.$notify({
                        type: 'warn',
                        group: 'notification',
                        title: 'Something was wrong',
                        text: 'Error Retrieving Cold Stock List - Contact Support',
                        duration: 5000,
                    });
                    return false;
                })
        },
        exportCsv () {
            if (this.exportOption == 1)
                this.exportSelectedCSV();
            else if (this.exportOption == 2)
                this.exportPageCSV();
            else if(this.exportOption == 3)
                this.exportAllCSV();
            this.showfileFormatPopup = false;
        },
        exportXlsx () {
            if (this.exportOption == 1)
                this.exportSelectedXLSX();
            else if (this.exportOption == 2)
                this.exportPageXLSX();
            else if(this.exportOption == 3)
                this.exportAllXLSX();
            this.showfileFormatPopup = false;
        },
        exportAllCSV() {
            let searchStringExport = this.searchString
            if (searchStringExport.length > 0) {
                searchStringExport = '?' + searchStringExport.substring(1)
            }

            Axios.get(globalStore.data.restApiUrl + "/sims/csv" + searchStringExport)
                .then(response => {
                    let csvContent = "data:text/csv;charset=utf-8," + response.data;
                    var fileLink = document.createElement('a');fileLink.href = csvContent;
                    fileLink.setAttribute('download', this.companyName + '.csv');
                    document.body.appendChild(fileLink);
                    fileLink.click();
                }).catch(error => {
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'SIMs export went wrong',
                        text: 'Error Exporting SIM Details - Contact Support',
                        duration: 3000,
                    });
                    console.log(error);
                });
        },
        exportPageCSV() {
            Axios.get(globalStore.data.restApiUrl + "/sims/csv" + '?page=' + this.sortSettings.page + '&size=' + this.sortSettings.size + '&sort=' + this.sortSettings.sort + '&desc=' + this.sortSettings.desc + this.searchString)
                .then(response => {
                    let csvContent = "data:text/csv;charset=utf-8," + response.data;
                    var fileLink = document.createElement('a');fileLink.href = csvContent;
                    fileLink.setAttribute('download', this.companyName + '.csv');
                    document.body.appendChild(fileLink);
                    fileLink.click();
                }).catch(error => {
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'SIMs export went wrong',
                        text: 'Error Exporting SIM Details - Contact Support',
                        duration: 3000,
                    });
                    console.log(error);
                });


        },
        exportSelectedCSV() {
            Axios.get(globalStore.data.restApiUrl + "/sims/csv" + '?selection=true')
                .then(response => {
                    let csvContent = "data:text/csv;charset=utf-8," + response.data;
                    var fileLink = document.createElement('a');fileLink.href = csvContent;
                    fileLink.setAttribute('download', this.companyName + '.csv');
                    document.body.appendChild(fileLink);
                    fileLink.click();
                }).catch(error => {
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'SIMs export went wrong',
                        text: 'Error Exporting SIM Details - Contact Support',
                        duration: 3000,
                    });
                    console.log(error);
                });
        },
        exportAllXLSX() {
            let searchStringExport = this.searchString
            if (searchStringExport.length > 0) {
                searchStringExport = '?' + searchStringExport.substring(1)
            }

            Axios.get(globalStore.data.restApiUrl + "/sims/xlsx" + searchStringExport, {responseType: 'blob'})
                .then((response) => {
                    const fileLink = URL.createObjectURL(new Blob([response.data],
                        {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,'}
                        )
                    );
                    const link = document.createElement('a')
                    link.href = fileLink
                    link.setAttribute('download', this.companyName + '.xlsx')
                    document.body.appendChild(link)
                    link.click()
                }).catch(error => {
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'SIMs export went wrong',
                        text: 'Error Exporting SIM Details - Contact Support',
                        duration: 3000,
                    });
                    console.log(error);
                });
        },
        exportPageXLSX() {
            Axios.get(
                globalStore.data.restApiUrl + "/sims/xlsx" + '?page=' + this.sortSettings.page + '&size=' + this.sortSettings.size + '&sort=' + this.sortSettings.sort + '&desc=' + this.sortSettings.desc + this.searchString,
                {responseType: 'blob'}
            )
                .then((response) => {
                    const fileLink = URL.createObjectURL(new Blob([response.data],
                        {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,'}
                        )
                    );
                    const link = document.createElement('a')
                    link.href = fileLink
                    link.setAttribute('download', this.companyName + '.xlsx')
                    document.body.appendChild(link)
                    link.click()
                }).catch(error => {
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'SIMs export went wrong',
                        text: 'Error Exporting SIM Details - Contact Support',
                        duration: 3000,
                    });
                    console.log(error);
                });


        },
        exportSelectedXLSX() {
            Axios.get(
                globalStore.data.restApiUrl + "/sims/xlsx" + '?selection=true',
                {responseType: 'blob'}
            )
                .then((response) => {
                    const fileLink = URL.createObjectURL(new Blob([response.data],
                        {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,'}
                        )
                    );
                    const link = document.createElement('a')
                    link.href = fileLink
                    link.setAttribute('download', this.companyName + '.xlsx')
                    document.body.appendChild(link)
                    link.click()
                }).catch(error => {
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'SIMs export went wrong',
                        text: 'Error Exporting SIM Details - Contact Support',
                        duration: 3000,
                    });
                    console.log(error);
                });
        },
        hideExportSelect() {
            this.$refs['fileFormatModal'].hide()

        },
        showExportSelect() {
            this.$refs['fileFormatModal'].show()
        },
        exportCsvNew() {
            this.$refs['fileFormatModal'].hide()

            let companyId = '';

            if (this.$cookies.get('userLevelId')) {
                companyId = '?companyId=' + this.$cookies.get('companyId')
            }

            Axios.get(globalStore.data.restApiUrl + "/cold-stock/csv" + companyId)
                .then(response => {
                    let csvContent = "data:text/csv;charset=utf-8," + response.data;
                    var fileLink = document.createElement('a');fileLink.href = csvContent;
                    fileLink.setAttribute('download', 'Cold stock list.csv');
                    document.body.appendChild(fileLink);
                    fileLink.click();
                }).catch(error => {
                this.$notify({
                    type: 'error',
                    group: 'notification',
                    title: 'SIMs export went wrong',
                    text: 'Something went wrong during SIMs export. Please contact with support.',
                    duration: 3000,
                });
                console.log(error);
            });
        },
        exportXlsxNew() {
            this.$refs['fileFormatModal'].hide()

            let companyId = '';

            if (this.$cookies.get('userLevelId')) {
                companyId = '?companyId=' + this.$cookies.get('companyId')
            }

            Axios.get(globalStore.data.restApiUrl + "/cold-stock/xlsx" + companyId, {responseType: 'blob'})
                .then((response) => {
                    const fileLink = URL.createObjectURL(new Blob([response.data],
                        {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,'}
                        )
                    );
                    const link = document.createElement('a')
                    link.href = fileLink
                    link.setAttribute('download', 'Cold stock list.xlsx')
                    document.body.appendChild(link)
                    link.click()
                }).catch(error => {
                this.$notify({
                    type: 'error',
                    group: 'notification',
                    title: 'SIMs export went wrong',
                    text: 'Something went wrong during SIMs export. Please contact with support.',
                    duration: 3000,
                });
                console.log(error);
            });
        },
        openFilters() {
            this.initialFilters.carrier.all = this.filters.carrier.all ? true : false
            this.initialFilters.carrier.simon = this.filters.carrier.simon ? true : false
            this.initialFilters.carrier.tmobile = this.filters.carrier.tmobile ? true : false
            this.initialFilters.carrier.vodafone = this.filters.carrier.vodafone ? true : false
            this.initialFilters.carrier.kore = this.filters.carrier.kore ? true : false
            this.$refs['filtersModal'].show();
        },
        setDefaultFilters() {
            this.filters.carrier.all = true
            this.filters.carrier.simon = this.simonCarrierAvailable ? true : false
            this.filters.carrier.tmobile = this.tmobileCarrierAvailable ? true : false
            this.filters.carrier.vodafone = this.vodafoneCarrierAvailable ? true : false
            this.filters.carrier.kore = this.koreCarrierAvailable ? true : false
        },
        setFilters() {
            this.filterString = ''
            if (this.filters.carrier.all == false) {
                if (this.filters.carrier.simon) {
                    this.filterString += '&carrierId=1'
                }
                if (this.filters.carrier.tmobile) {
                    this.filterString += '&carrierId=2'
                }
                if (this.filters.carrier.vodafone) {
                    this.filterString += '&carrierId=3'
                }
                if (this.filters.carrier.kore) {
                    this.filterString += '&carrierId=4'
                }
            }
            this.getColdStocks(true)
            this.$refs['filtersModal'].hide();
        },
        cancelFilters() {
            this.filters.carrier.all = this.initialFilters.carrier.all ? true : false
            this.filters.carrier.simon = this.initialFilters.carrier.simon ? true : false
            this.filters.carrier.tmobile = this.initialFilters.carrier.tmobile ? true : false
            this.filters.carrier.vodafone = this.initialFilters.carrier.vodafone ? true : false
            this.filters.carrier.kore = this.initialFilters.carrier.kore ? true : false
            this.$refs['filtersModal'].hide();
        },
        filtersAllCarriers() {
            if (this.filters.carrier.all) {
                this.filters.carrier.simon = this.simonCarrierAvailable ? true : false
                this.filters.carrier.tmobile = this.tmobileCarrierAvailable ? true : false
                this.filters.carrier.vodafone = this.vodafoneCarrierAvailable ? true : false
                this.filters.carrier.kore = this.koreCarrierAvailable ? true : false
            } else {
                this.filters.carrier.simon = false
                this.filters.carrier.tmobile = false
                this.filters.carrier.vodafone = false
                this.filters.carrier.kore = false
            }
        },
        filtersCarrier() {
            if (((this.filters.carrier.simon && this.simonCarrierAvailable) || this.simonCarrierAvailable == false) &&
                ((this.filters.carrier.tmobile && this.tmobileCarrierAvailable) || this.tmobileCarrierAvailable == false) &&
                ((this.filters.carrier.vodafone && this.vodafoneCarrierAvailable) || this.vodafoneCarrierAvailable == false) &&
                ((this.filters.carrier.kore && this.koreCarrierAvailable) || this.koreCarrierAvailable == false)) {
                this.filters.carrier.all = true
            } else {
                this.filters.carrier.all = false
            }
        },
        selectAllFilters() {
            this.filters.carrier.all = true
            this.filters.carrier.simon = true
            this.filters.carrier.tmobile = true
            this.filters.carrier.vodafone = true
            this.filters.carrier.kore = true
        },
        unselectAllFilters() {
            this.filters.carrier.all = false
            this.filters.carrier.simon = false
            this.filters.carrier.tmobile = false
            this.filters.carrier.vodafone = false
            this.filters.carrier.kore = false
        }
    },
    created() {
        this.showMobileElements();
        this.companyId = this.$cookies.get('companyId') ? this.$cookies.get('companyId') : this.$session.get('companyId');

        if (this.$cookies.get('simonCarrierAvailable') == 'true' || this.$session.get('simonCarrierAvailable')) {
            this.simonCarrierAvailable = true;
        } else {
            this.simonCarrierAvailable = false
            this.filters.carrier.simon = false
        }
        if (this.$cookies.get('tmobileCarrierAvailable') == 'true' || this.$session.get('tmobileCarrierAvailable')) {
            this.tmobileCarrierAvailable = true;
        } else {
            this.tmobileCarrierAvailable = false
            this.filters.carrier.tmobile = false
        }
        if (this.$cookies.get('vodafoneCarrierAvailable') == 'true' || this.$session.get('vodafoneCarrierAvailable')) {
            this.vodafoneCarrierAvailable = true;
        } else {
            this.vodafoneCarrierAvailable = false
            this.filters.carrier.vodafone = false
        }
        if (this.$cookies.get('koreCarrierAvailable') == 'true' || this.$session.get('koreCarrierAvailable')) {
            this.koreCarrierAvailable = true;
        } else {
            this.koreCarrierAvailable = false
            this.filters.carrier.kore = false
        }

        if (this.$cookies.get('token')) {
            this.coldStockAccess = String(this.$cookies.get('coldStockAccess'));
        } else if (this.$session.get('token')) {
            this.coldStockAccess = String(this.$session.get('coldStockAccess'));
        }

        this.companyName = this.$cookies.get('companyName') ? this.$cookies.get('companyName') : this.$session.get('companyName')

        if (this.$cookies.get('nbIoTPlans') == 'true') {
            this.nbIoTAvailable = true
        } else if (this.$session.get('nbIoTPlans') == true) {
            this.nbIoTAvailable = true
        } else {
            this.nbIoTAvailable = false
        }
        if (this.$cookies.get('catM1Plans') == 'true') {
            this.catM1Available = true
        } else if (this.$session.get('catM1Plans') == true) {
            this.catM1Available = true
        } else {
            this.catM1Available = false
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            if (from.name == 'SIM Activation') {
                if (vm.$session.get('coldstockSortSettings')) {
                    let sort = vm.$session.get('coldstockSortSettings');
                    vm.sortSettings = {
                        page: sort.page,
                        size: sort.size,
                        sort: sort.sort,
                        desc: sort.desc
                    }
                } else {
                    vm.sortSettings = {
                        page: 1,
                        size: 40,
                        sort: 1,
                        desc: true
                    }
                }
                if (vm.$session.get('coldstockSortSettings')) {
                    vm.paginationCount = Number(vm.$session.get('paginationCount'));
                } else {
                    vm.paginationCount = 1
                }
                vm.getColdStocks(false)
            } else {
                if (vm.$session.get('coldstockSortSettings')){
                    vm.$session.remove('coldstockSortSettings')
                }
                if (vm.$session.get('paginationCount')){
                    vm.$session.remove('paginationCount')
                }
                vm.getColdStocks(true)
            }
        })
    },
    beforeDestroy() {
        this.$session.set('coldstockSortSettings', this.sortSettings)
        this.$session.set('paginationCount', this.paginationCount)
    }
}
</script>

<style src="spinkit/scss/spinkit.scss" lang="scss" />
<style lang="scss">
.wrapper-cold-stock {
    .card {
        margin-bottom: 20px;
    }
    .card-header {
        display: flex;
        justify-content: space-between;
    }

    .card-body {
        padding: 0;
        padding-top: 20px;
        padding-bottom: 20px;
        .export-control {
            display: flex;
            align-items: flex-end;
            justify-content: flex-end;

            .btn-primary {
                padding-left: 10px;
                padding-right: 10px;
                text-align: center;
                margin-left: 15px;
            }
        }
    }

    select.form-control {
        display: inline-block;
        &.export-dropdown {
            max-width: 150px;
        }
    }

    .card-body {
        .col-md-2.text-right label {
            margin: 7px 10px 0 0;
        }
        .filter-row {
            .filters-button {
                margin-right: 20px;
            }
            .cold-stock-button {
                margin-right: 20px;
                button {
                    margin-left: 10px;
                    white-space: nowrap;
                }
            }
        }
    }

    .bottom-card {
        bottom: 0;
        left: 20px;
        right: 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 0;
        background-color: #fff;
    }

    .wrapper-modal {
        position: fixed;
        width: 100vw;
        height: 100vh;
        /*min-height: 100vh;*/
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background-color: rgba(44, 44, 44, 0.9);
        z-index: 3030;

        &.wrapper-disable {
            display: none;
        }

        .file-format-popup {
            position: relative;
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 500px;
            background-color: #fff;
            padding: 20px;
            -webkit-border-radius: 5px;
            -moz-border-radius: 5px;
            border-radius: 5px;

            h3 {
                font-size: 15px;
                margin-top: 8px;
                margin-bottom: 20px;
            }

            .btn {
                width: 100px;
            }

            .btn-primary {
                margin: 0 10px 20px;
            }

            .btn-light {
                margin: 10px 0 0;
            }

            .csv {
                background-color: #00559F;
                border-color: #00559F;
            }
            .xls {
                background-color: #207245;
                border-color: #207245;
            }

            .close-icon {
                position: absolute;
                top: 20px;
                right: 20px;
                cursor: pointer;
            }
        }
    }
}

.fts-checkbox-table {
    cursor: pointer;
}

#fileFormatModal___BV_modal_header_ {
    padding-bottom: 0;
}

#fileFormatModal___BV_modal_body_ {
    padding-top: 0;
    .file-format-popup {
        display: flex;
        flex-direction: column;
        align-items: center;
        background-color: #fff;
        padding: 0 20px 20px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;

        h3 {
            font-size: 15px;
            margin-top: 8px;
            margin-bottom: 20px;
        }

        .btn {
            width: 100px;
        }

        .btn-primary {
            margin: 0 10px 20px;
        }

        .btn-light {
            margin: 10px 0 0;
        }

        .csv {
            background-color: #00559F;
            border-color: #00559F;
        }
        .xls {
            background-color: #207245;
            border-color: #207245;
        }

        .close-icon {
            position: absolute;
            top: 20px;
            right: 20px;
            cursor: pointer;
        }
    }
}

.fts-bottom-table {
    .btns-box {
        position: relative;
        display: flex;
        .btn {
            margin-left: 20px;
        }
        .move-to-activation-btn {
            &+.disable-hint {
                display: none;
                position: absolute;
                bottom: calc(100% + 5px);
                right: 0;
                padding: 10px;
                background-color: #241717;
                color: #ffffff;
                -webkit-border-radius: 5px;
                -moz-border-radius: 5px;
                border-radius: 5px;
                white-space: nowrap;
            }
            &:hover {
                &+.disable-hint {
                    display: block;
                }
            }
        }
    }
}

#filtersModal {
    .modal-body {
        padding: 0;
        .filters-inner {
            position: relative;
            display: flex;
            padding: 20px;
            .carrier-column {
                width: 150px;
                h3 {
                    margin: 0 0 14px;
                    font-size: 15px;
                    font-weight: 700;
                }
            }
            .simon-types-column {
                width: 150px;
                h3 {
                    margin: 0 0 14px;
                    font-size: 15px;
                    font-weight: 700;
                }
            }
            .unselect-box {
                position: absolute;
                right: 20px;
                top: 20px;
                .fa-close {
                    margin-left: 20px;
                }
                a {
                    color: #0088ff;
                    text-transform: uppercase;
                    font-weight: 700;
                    cursor: pointer;
                }
            }
        }
        .control-bar {
            display: flex;
            justify-content: space-between;
            padding: 12px 20px;
            background-color: #f9f9f9;
            border-top: 0;
            .right-side {
                .btn-primary {
                    margin-left: 10px;
                }
            }
        }
    }
}

.dark-theme {

    #selectCarrier___BV_modal_header_ {
        background-color: #3a4149;
        border: 0;
    }

    .modal-header {
        button {
            color: #fff;
        }
    }
    .modal-content {
        background-color: #3a4149;
        color: #edeeef;
        .carrier-option {
            .light-mode {
                display: none;
            }
            .dark-mode {
                display: block;
            }
        }
    }

    .table thead th {
        color: #fff;
        border-color: #1A1C1D;
    }
    .table tbody tr td {
        background-color: #2F353A;
        border-color: #1A1C1D;
        color: #fff;
    }
    .table tbody tr:nth-of-type(odd) td {
        background-color: #2F353A;
    }
    .table tbody tr:hover td {
        background-color: #0088FF;
        color: #fff;
    }
    .wrapper-cold-stock .bottom-card {
        background-color: transparent;
    }

    .wrapper-modal {
        .file-format-popup {
            background-color: #3a4149;
            color: #EDEEEF;
        }
    }
}

#selectCarrier___BV_modal_header_ {
    padding-bottom: 0;
}

#selectCarrier___BV_modal_body_ {
    display: flex;
    flex-direction: column;
    align-content: center;
    align-items: center;

    padding-top: 0;
    padding-bottom: 40px;

    img {
        max-width: 16px;
        margin-bottom: 12px;
    }

    strong {
        margin-bottom: 18px;
        font-size: 15px;
        line-height: 20px;
    }

    p {
        font-size: 14px;
        line-height: 24px;
    }

    .select-carrier-box {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;

        .carrier-option {
            width: 180px;
            padding: 10px 20px;
            margin-bottom: 10px;

            border: 1px solid #80868D;
            border-radius: 5px;
            text-align: center;
            box-sizing: border-box;
            cursor: pointer;
            opacity: .6;

            &:hover {
                opacity: 1;
            }
            img {
                width: 100%;
                height: 40px;
                max-width: none;
                margin: 0;
                cursor: pointer;
            }



        }
    }
}

.mobile-wrapper-buttons {
    display: none;

    .buttons-list {
        button {
            margin: 0;
        }
    }
}

.cold-stock-mobile {
    width: 100%;
}
</style>
